/**
 * Handle behavior of the player
 */
const Player = {
	// the audio urls.
	audioURLs: [],
	// the HTMLAudioElements
	audios: [],
	// the index in the audios array of the active HTMLAudioElement
	activeAudioIndex: null,
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready
		document.addEventListener('DOMContentLoaded', Player._ready);
	},
	/**
	 * Handle's document ready
	 */
	_ready: () => {
		// get the audio URLs. leave in the empty audio strings for exact row to audio indexing.
		let audioURLs = playlistData.map(row => row.audio)

		// listen for their load if they exist
		if (audioURLs.length > 0) {
			audioURLs.forEach((audioURL, index) => {
				// convert to HTMLAudioElement
				const audio = new Audio(audioURL);

				// Wait for the metadata to load before accessing the duration
				audio.addEventListener('loadeddata', Player._audioDataLoadedHandler.bind(null, index));
				// listen for timeupdate on each audio
				audio.addEventListener('timeupdate', Player._updateTimeHandler.bind(null, index));
				// listen for audio stop
				audio.addEventListener('ended', Player._audioEndedHandler.bind(null, index));
				// Handle error if the file is not found or cannot be loaded
				audio.addEventListener('error', function (e) {
					// allow empty audio
					if( audioURL.length > 0 ){
						console.log(`Couldn't load audio file from URL: ${audioURL}`)
					}
				});

				// push audio to the audios array
				Player.audios.push(audio);
			});
		}
	},
	/**
	 * Handle loadeddata event
	 * @param {int} index the index in the audios array
	 * @param {object} e the event object
	 */
	_audioDataLoadedHandler: (index, e) => {
		// dispatch an event so the UI can listen and update.
		document.dispatchEvent(new CustomEvent('pammbt:guide:player:loadeddata', {
			bubbles: true,
			detail: {
				audio: e.target,
				index: index
			}
		}));
	},
	/**
	 * Handles time update
	 * @param {int} index the index in the audios array
	 * @param {object} e the event object
	 */
	_updateTimeHandler: (index, e) => {
		// dispatch an event so the UI can listen and update.
		document.dispatchEvent(new CustomEvent('pammbt:guide:player:timeupdate', {
			bubbles: true,
			detail: {
				audio: e.target,
				index: index
			}
		}));
	},
	/**
	 * Handles audio ending
	 * @param {int} index the index in the audios array
	 * @param {object} e the event object
	 */
	_audioEndedHandler : (index, e) => {
		// dispatch an event so the UI can listen and update.
		document.dispatchEvent(new CustomEvent('pammbt:guide:player:ended', {
			bubbles: true,
			detail: {
				audio: e.target,
				index: index
			}
		}));
	},
	/**
	 * Plays the active audio and sets the active audio
	 * @param {int} audioNum index in the audios array
	 */
	_playAudio: (audioNum = 0) => {
		console.log(`Playing audio ${audioNum}`, Player.audios[audioNum]);
		Player.audios[audioNum].play();
		Player.activeAudioIndex = audioNum;
	},
	/**
	 * Pauses the active audio
	 */
	_pauseAudio: () => {
		if (Player.activeAudioIndex !== null) {
			Player.audios[Player.activeAudioIndex].pause();
		}
	},
	/**
	 * Returns if the current audio is playing or not
	 * @returns boolean if the current audio is playing or not
	 */
	_isPlaying: () => {
		if (Player.activeAudioIndex !== null) {
			return !Player.audios[Player.activeAudioIndex].paused;
		}
		return false;
	},
	/**
	 * Seek to time in active audio.
	 * @param {double} audioTime time in seconds
	 */
	_seekAudio: (audioTime) => {
		if (Player.activeAudioIndex !== null) {
			Player.audios[Player.activeAudioIndex].fastSeek(audioTime);
		}
	},
	/**
	 * Returns the duration of the current audio.
	 * @returns double the duration of the current audio
	 */
	_getDuration : () => {
		if (Player.activeAudioIndex !== null) {
			return Player.audios[Player.activeAudioIndex].duration;
		}
	}
};

export default Player;